$(document).ready(function () {
  
  jQuery('.cart__checkout').click(function(){
    window.location.href = "/checkout"
  })
  
  // By default, the filter will be open along with the loading.
  $("summary.filter-group__heading").click();
  $(".collection__sidebar").css("opacity", "1");

  // Replace the symbol on product page
  setTimeout(function () {
  $(".spb-label-tooltip .spb-tooltip").each(function () {
    var htmlContent = $(this).html();
    var updatedContent = htmlContent.replace("ⓘ", "");
    $(this).html(updatedContent);
    $("#infiniteoptions-container .spb-tooltip").css("opacity", "1");
  });
}, 4200);

  $("summary.cart__widget__title").click();
  $("details.accordion:nth-child(1) summary.accordion__title.h6").click();
  // $("details.cart__widget.cart__widget--products.accordion").css("pointer-events", "none");

    $('.btn--ar product-single__view-in-space').click(function(){
        $('.product__media.deferred-media').click();
    });
    
      $('.btn--ar product-single__view-in-space').click(function(){
        $('.product__media.deferred-media button').click();
    });

  // --- BUNDLE REMOVAL LOGIC: Remove entire bundle in one click ---

  function getBundleItemsToRemove(clickedButton) {
    const clickedItem = clickedButton.closest('[data-item]');
    if (!clickedItem) return [clickedButton];

    const bundleGroup = clickedItem.getAttribute('data-bundle-group');
    const bundleParent = clickedItem.getAttribute('data-bundle-parent');
    const itemsToRemove = [clickedButton];

    // CRITICAL: If item has BOTH attributes (edge case), prioritize as parent
    if (bundleGroup && bundleParent) {
      console.warn('Bundle item has both group and parent attributes. Treating as parent.');
    }

    // If removing a parent item, include all add-ons
    if (bundleGroup) {
      const addons = document.querySelectorAll(`[data-bundle-parent="${bundleGroup}"]`);
      addons.forEach(function (addon) {
        const addonRemoveBtn = addon.querySelector('[data-item-remove]');
        if (addonRemoveBtn) itemsToRemove.push(addonRemoveBtn);
      });
    }

    // If removing an add-on, include the parent AND all other add-ons
    if (!bundleGroup && bundleParent) {
      const parent = document.querySelector(`[data-bundle-group="${bundleParent}"]`);
      if (parent) {
        const parentRemoveBtn = parent.querySelector('[data-item-remove]');
        if (parentRemoveBtn) itemsToRemove.push(parentRemoveBtn);
      }
      
      const allAddons = document.querySelectorAll(`[data-bundle-parent="${bundleParent}"]`);
      allAddons.forEach(function(addon) {
        const addonRemoveBtn = addon.querySelector('[data-item-remove]');
        if (addonRemoveBtn && addonRemoveBtn !== clickedButton) {
          itemsToRemove.push(addonRemoveBtn);
        }
      });
    }

    return itemsToRemove;
  }

  async function removeBundleItems(itemsToRemove) {
    if (itemsToRemove.length <= 1) return false; // Let default handler deal with single items

    const cartApiUrl = '/cart/update.js';

    try {
      const ids = itemsToRemove
        .map(function (button) {
          const item = button.closest('[data-item]');
          return item ? item.getAttribute('data-item') : null;
        })
        .filter(Boolean);

      // Validate keys exist in current cart
      const currentCart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
      const validIds = ids.filter(function(key) {
        return currentCart.items.some(function(item) {
          return item.key === key;
        });
      });

      if (validIds.length) {
        
        // Separate add-ons from parents - remove add-ons FIRST
        const itemsWithKeys = itemsToRemove.map(function(button) {
          const item = button.closest('[data-item]');
          return {
            button: button,
            key: item ? item.getAttribute('data-item') : null,
            isParent: item && item.getAttribute('data-bundle-group')
          };
        }).filter(obj => obj.key);
        
        const addons = itemsWithKeys.filter(obj => !obj.isParent);
        const parents = itemsWithKeys.filter(obj => obj.isParent);
        const removeOrder = [...addons, ...parents];
        
        for (let i = 0; i < removeOrder.length; i++) {
          const key = removeOrder[i].key;
          const singleUpdate = {};
          singleUpdate[key] = 0;
          
          await fetch(cartApiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: singleUpdate }),
          });
          
          if (i < removeOrder.length - 1) {
            await new Promise(resolve => setTimeout(resolve, 100));
          }
        }
        
        // Verify removal - retry any items that still exist
        const cartCheck = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
        const stillThere = cartCheck.items
          .filter((li) => validIds.includes(li.key))
          .map((li) => li.key);

        if (stillThere.length) {
          const retryUpdates = {};
          stillThere.forEach((k) => {
            retryUpdates[k] = 0;
          });
          
          await fetch(cartApiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: retryUpdates }),
          });
        }
      }

      // Refresh cart
      setTimeout(function () {
        try {
          const cartElement = document.querySelector('cart-items');
          if (cartElement && typeof cartElement.getCart === 'function') {
            cartElement.getCart();
          } else {
            window.location.reload();
          }
        } catch (err) {
          window.location.reload();
        }
      }, 150);

      return true;
    } catch (error) {
      console.error('Bundle removal error:', error);
      // Fallback: let default handler deal with it
      return false;
    }
  }

  // Intercept cart removal clicks BEFORE default handler
  $(document).on('click', '[data-item-remove]', function (e) {
    const button = this;
    const itemsToRemove = getBundleItemsToRemove(button);

    // If we have bundle items, handle removal ourselves
    if (itemsToRemove.length > 1) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation(); // CRITICAL: Stop other handlers

      // Async handling - don't await (let button click proceed)
      removeBundleItems(itemsToRemove).catch(function (err) {
        console.error('Failed to remove bundle:', err);
      });
    }
    // Otherwise let default handler deal with it
  });
  // --- END BUNDLE REMOVAL LOGIC ---
});
